
// import publicList from '@/components/publicList/publicList.vue'
import publicList from '@/components/publicLists/publicList.vue'
import { mapActions, mapState } from 'vuex'
// import headBlock from '@/view/components/home/head/headBlock.vue'
// import page from '@/components/page/page.vue'
// import footerBlock from '../components/home/footerBlock/footerBlock.vue'
// import { auyFun } from '@/api'
// import merge from "webpack-merge";
function convertString (str) {
  const parts = str.split('-');
  const id = parts.pop();
  const productName = parts.join('-');
  return `${productName}?id=${id}`;
}
function activeString (str) {
  const parts = str.split('-');
  const id = parts.pop();
  const productName = parts.join('-');
  return `${productName}?active=${id}`;
}

export default {
  name: 'classify',
  components: { publicList },
  async asyncData ({ error, app, params, query, req }) {
    let classification = {
      cat_name_en: ""
    }
    let list = [], total = Number, totalFA = false, topTips, topTipsHide, cat_name_en, activity, searkeyList = [], slowList = false, empty_msg = []
    var result, listarr, cats, is_oversea
    //搜索
    if (query.goods_name) {
      cats = {
        cat_id: "",
        goods_name: query.goods_name,
      }
      listarr = {
        page: 1,
        pz: 15,
        cat_id: "",
        goods_name: query.goods_name,
      }
      //分类
    } else if (params.id) {
      const match = params.id.match(/-(\d+)$/);
      if (match && match[1]) {
        result = match[1];
        if (result == 0 || result == 1) {
          //9-21
          listarr = {
            page: 1,
            pz: 15,
            is_oversea: result
          }
          cats = {
            is_oversea: result
          }

          is_oversea = result
        } else {
          listarr = {
            page: 1,
            pz: 15,
            cat_id: result
          }
          cats = {
            cat_id: result
          }
        }
      } else {
        //各种活动页
        listarr = {
          page: 1,
          pz: 15,
          activity: params.id
        }
        cats = {
          cat_id: params.id,
        }
      }
      activity = params.id
    } else {
      cats = {
        cat_id: "",
      }
      listarr = {
        page: 1,
        pz: 15,
        cat_id: "",
      }
    }

    // const g_id = params.id;
    try {
      const { status, data, code } = await app.$api.auyFun.SIDEBAR(cats);

      if (status === 200) {

        classification = data.data.category
      }
    } catch (error) { }

    try {
      const { status, data, code } = await app.$api.auyFun.TOPCATTIT(cats);

      if (status === 200) {

        topTips = data.data.cate_desc
        topTipsHide = data.data.cate_desc_text
        cat_name_en = data.data.cat_name_en
      }
    } catch (error) { }

    //列表
    try {
      const { status, data } = await app.$api.auyFun.ESGETLIST(listarr);
      if (status === 200) {
        console.log(data.data)
        list = data.data; // 赋值
        empty_msg = data.data.empty_msg
        if (query.goods_name) {
          if (data.data.data.length == 0) {
            slowList = true

          }
        }
        total = data.data.total
        totalFA = true
      }
    } catch (error) {
    }
    return { classification, list, total, totalFA, is_oversea, topTips, topTipsHide, cat_name_en, activity, searkeyList, slowList, empty_msg };
  },
  data () {
    return {
      empty_msg: [],
      searkeyList: [],
      topTipsHide: "",
      activity: "",
      is_catshow: true,
      totalFA: false,
      total: Number,
      currentPage: 1,
      tags: [],
      showLoading: false,
      slowList: false,
      is_oversea: null,
      cat_name_en: "",
      topTips: "",
      topTipsHid: "",
      classification: {}, //商品分类
      merchant: [], // 筛选商家
      options: [
        {
          value: '0',
          label: 'Featured'
        },
        {
          value: '1',
          label: 'Price Low to High'
        },
        {
          value: '2',
          label: 'Price High to Low'
        },
        {
          value: '3',
          label: 'Customer Reviews'
        },
        {
          value: '4',
          label: 'Newest Arrivals'
        }
      ],
      value: '',
      checkedCities: [],
      cat_id: "",
      goods_name: this.$route.query.goods_name,
      score: [4, 3, 2, 1],
      shopScore: 5,
      price_min: '',
      price_max: '',
      UUID: "",//localStorage.getItem('uuid')
      price: [
        { min: 0, max: 25 },
        { min: 25, max: 50 },
        { min: 50, max: 100 },
        { min: 100, max: 200 },
        { min: 200, max: 9999 }
      ],
      priceArr: [], //筛选中的金额
      page: 1,
      debingList: [],
      list: {
        data: []
      }, //商品数据
      goodsList: [] // 推荐商品
    }
  },
  // watch: {
  //   // 方法1
  //   $route (to, from) {
  //     
  //     if (this.$route.query.goods_name) {
  //       this.tags = []
  //       this.tags.push(this.$route.query.goods_name)
  //       // console.log(['标签一', '标签二', '标签三'])
  //     }
  //     this.goods_name = this.$route.query.goods_name

  //   },
  // },
  head () {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: this.cat_name_en,
      meta: [
        {
          name: "keywords",
          content:
            this.cat_name_en,
        },
        // hid是一个唯一标识
        {
          hid: 'description', name: 'names', content: this.topTipsHide
        },
      ],
    };
  },
  created () {
    // this.classify()
    // this.shopList()
    // this.relatedGoods()
    // if (this.$route.query.goods_name) {
    //   this.tags.push(this.$route.query.goods_name)
    // }
  },
  computed: {
    // ...mapState('shopCart', ['classifyStr']),
    money () {
      return (sum) => {
        return sum == 0 ? 'Under' : sum >= 9999 ? 'Above' : sum
      }
    }
  },
  watch: {
    '$route.query': function (newQuery, oldQuery) {


      this.goods_name = this.$route.query.goods_name
      this.page = 1
      this.classify()
      this.shopList()
      // 当查询参数发生变化时，这里的代码会被执行
      // console.log('查询参数发生了变化');
      // console.log('旧的查询参数：', oldQuery);
      // console.log('新的查询参数：', newQuery);
      // 在这里可以根据参数的变化执行相应的业务逻辑，比如重新获取数据等
    },

  },

  destroyed () {
    // this.SETCLASSIFY()
  },
  methods: {
    // ...mapActions('shopCart', ['SETCLASSIFY']),
    // 列表分页
    pageChage (k) {
      this.page = k
      // localStorage.setItem('storepz', k)
      this.shopList()

    },
    //加入购物车后前端跟新数据
    update (data) {
      this.list.data.forEach((j, k) => {
        if (data.goods_id == j.goods_id) {
          j.cart_num = data.goods_num
        }
      })
    },
    handleClose (tag) {

      this.tags.splice(this.tags.indexOf(tag), 1);
      this.$router.go(0);
    },
    selectFun (j) {
      this.page = 1
      // this.$refs.pageFun.childMethod();
      // this.SETCLASSIFY(j)
      this.shopList()
    },
    async classify () {
      // 获取商品筛选条件数据
      let params = {
        goods_name: this.goods_name,
        cat_id: this.cat_id
      }
      // if (this.cat_id) params.cat_id = this.cat_id
      // else params.goods_name = this.goods_name

      const res = await this.$axios({
        url: "/pc/sidebar",
        method: 'get',
        params: params
      })
      if (res.code == 200) {
        this.classification = res.data.category
        // let paramsY = {
        //   cat_id: 0,
        //   cat_name: 'ALL',
        //   cat_name_en: "ALL"
        // }
        // this.classification.unshift(paramsY)
        this.merchant = res.data.shop
      }
    },
    async debing () {
      // 获取商品筛选条件数据
      let params = {
        page: this.page,
        pageSize: 3,
        position_id: 2,
        cat_id: this.cat_id
      }
      // if (this.cat_id) params.cat_id = this.cat_id
      // else params.goods_name = this.goods_name

      await this.$api.auyFun.BIDDING(params).then((res) => {
        if (res.code == 200) {
          this.debingList = res.data.data
        }

      })
    },
    relatedGoods () {
      let params = {
        num: 50
      }
      this.$api.auyFun.GET_RELATEDGOODS(params).then((res) => {
        this.goodsList = res.data.data
      })
    },
    searkeylist () {

      this.$api.auyFun.SEARCHKEYLIST().then((res) => {
        this.searkeyList = res.data.data
      })
    },

    filtrate (item) {
      this.tags = []
      this.tags.push(item.cat_name_en)
      this.cat_id = item.cat_id
      this.page = 1
      // this.$refs.pageFun.childMethod();
      this.shopList()
      this.classify()
    },
    multiSelect () {
      // 卖家筛选
      this.shopList()
    },
    shopList (val) {

      var _this = this
      _this.showLoading = true
      // this.list = {
      //   data: []
      // }
      // 获取商品列表数据
      window.scrollTo(0, 0)
      let params = {
        page: _this.page,
        suppliers_ids: _this.checkedCities,
        score: val,
        min_price: _this.priceArr[0],
        max_price: _this.priceArr[1],
        pz: 15,
        goods_name: _this.goods_name,
        keywords_list: _this.$route.query.keywordslist,
        cat_id: _this.cat_id,
        sort: _this.value,
        uuid: _this.UUID,
        is_oversea: _this.is_oversea,
        activity: _this.activity
      }

      _this.$api.auyFun.ESGETLIST(params).then((res) => {
        _this.showLoading = false
        if (res.data.code == 200) {
          _this.list = res.data.data
          _this.total = res.data.data.total
          _this.empty_msg = res.data.data.empty_msg
          if (res.data.data.data.length == 0) {
            // _this.slowList = true
            // _this.searkeylist()
          }
        }
      })
        .catch((e) => {
          _this.showLoading = false
          // _this.slowList = true
        })
    },
    onPage (e) {
      // 分页
      this.page = e
      this.shopList()
    },
    onScore (e) {
      // 评分筛选
      this.shopList(e)
    },
    onPrice (e) {
      // 金额筛选
      this.priceArr = Object.values(e)
      this.shopList()
    },
    custom () {
      // 自定义金额
      let str = this.price_min + ',' + this.price_max
      this.priceArr = str.split(',')
      this.shopList()
    },
    tolink (item) {
      // 跳转详情
      // this.$router.push({
      //   path: '/detail',
      //   query: {
      //     goods_id: item.goods_id
      //   }
      // })
      var routeData = this.$router.resolve({
        path: '/detail',
        query: { goods_id: item.goods_id }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
